import React from 'react';
import s from '../../s.module.less';

type Option = { label: string; value: any };

type Props = {
    // 由 Form.Item 注入
    value?: any;
    onChange?: (v: any) => void;
    options: Option[];
    name: string;
};

// 卡片式单选（对齐原型 .cred-type-option）：整块可点，选中态蓝框 + 浅蓝底
export default function CardRadioGroup({ value, onChange, options, name }: Props) {
    return (
        <div>
            {options.map((o) => {
                const checked = value === o.value;
                return (
                    <label key={String(o.value)} className={checked ? `${s.typeOption} ${s.selected}` : s.typeOption}>
                        <input type="radio" name={name} checked={checked} onChange={() => onChange?.(o.value)} />
                        <span className={s.typeOptionDot} aria-hidden />
                        <div className={s.typeOptionLabel}>{o.label}</div>
                    </label>
                );
            })}
        </div>
    );
}
